import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import dayjs from "dayjs";

const AffiliateDetailsDialog = () => {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);

  const handleClose = () => {
    dispatch({ type: CLOSE_DIALOGUE });
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Creator Request Details</h5>
          <IconButton onClick={handleClose}>
            <Cancel />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="row">
          {/* Profile Section */}
          <div className="col-md-12 mb-4">
            <div className="text-center">
              <img
                src={dialogueData?.image || dialogueData?.logo || "/dummy.png"}
                alt="profile"
                className="rounded-circle mb-3"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/dummy.png";
                }}
              />
              <h5>{dialogueData?.firstName} {dialogueData?.lastName}</h5>
              <p className="text-muted">@{dialogueData?.businessTag}</p>
            </div>
          </div>

          {/* Basic Information */}
          <div className="col-md-6 mb-3">
            <h6 className="text-primary mb-3">Basic Information</h6>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <td className="fw-bold">Store Name:</td>
                  <td>{dialogueData?.storeName || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Category:</td>
                  <td>{dialogueData?.category || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Email:</td>
                  <td>{dialogueData?.email}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Mobile:</td>
                  <td>{dialogueData?.countryCode} {dialogueData?.mobileNumber}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Gender:</td>
                  <td>{dialogueData?.gender || "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Address Information */}
          <div className="col-md-6 mb-3">
            <h6 className="text-primary mb-3">Address Details</h6>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <td className="fw-bold">Address:</td>
                  <td>{dialogueData?.address?.address || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Landmark:</td>
                  <td>{dialogueData?.address?.landMark || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">City:</td>
                  <td>{dialogueData?.address?.city || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">State:</td>
                  <td>{dialogueData?.address?.state || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Country:</td>
                  <td>{dialogueData?.address?.country || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Pin Code:</td>
                  <td>{dialogueData?.address?.pinCode || "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Bank Details */}
          <div className="col-md-12 mb-3">
            <h6 className="text-primary mb-3">Bank Details</h6>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <td className="fw-bold" width="25%">Bank Name:</td>
                  <td>{dialogueData?.bankDetails?.bankName || "N/A"}</td>
                  <td className="fw-bold" width="25%">Account Holder:</td>
                  <td>{dialogueData?.bankDetails?.bankBusinessName || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Account Number:</td>
                  <td>{dialogueData?.bankDetails?.accountNumber || "N/A"}</td>
                  <td className="fw-bold">IFSC Code:</td>
                  <td>{dialogueData?.bankDetails?.IFSCCode || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Branch Name:</td>
                  <td colSpan="3">{dialogueData?.bankDetails?.branchName || "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Description */}
          {dialogueData?.description && (
            <div className="col-md-12 mb-3">
              <h6 className="text-primary mb-2">Description</h6>
              <p className="border rounded p-2">{dialogueData?.description}</p>
            </div>
          )}

          {/* Status and Dates */}
          <div className="col-md-12">
            <div className="d-flex justify-content-between align-items-center border-top pt-3">
              <div>
                <span className="fw-bold">Status: </span>
                <span className={`badge ${dialogueData?.isAccepted ? "bg-success" : "bg-warning"}`}>
                  {dialogueData?.isAccepted ? "Approved" : "Pending"}
                </span>
              </div>
              <div>
                <span className="fw-bold">Request Date: </span>
                {dayjs(dialogueData?.createdAt).format("DD MMM YYYY, HH:mm")}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AffiliateDetailsDialog;